import { forwardRef } from "react";
import { useTranslation } from "react-i18next";

const PaypalPayment = forwardRef(
  ({children,},
  ) => {
    const { t } = useTranslation("signup");
    return (
      <>
      <div className="payment-form">
        <div className="payment-card">
          <div className="head-payment-card">
            <div className="content">
              <h4>{t("pay_by_paypal")}</h4>
              <p>{t("pay_by_paypal_description")}</p>
            </div>
          </div>
        </div>
          {children}
      </div>
      </>
    );
  },
);

export default PaypalPayment;
